{
  "slug": "iq-vs-intelligence",
  "title": "IQ vs Intelligence: क्या वे एक ही हैं?",
  "description": "एक मानकीकृत आईक्यू स्कोर और मानव बुद्धि की व्यापक अवधारणा के बीच अंतर समझें।",
  "summary": "बुद्धि एक व्यापक मनोवैज्ञानिक अवधारणा है। IQ चयनित संज्ञानात्मक कार्यों पर प्रदर्शन पर आधारित एक मानकीकृत अनुमान है।",
  "sections": [
    {
      "heading": "एक अंक से अधिक बुद्धिमत्ता",
      "paragraphs": [
        "मनोवैज्ञानिकों ने सीखने, तर्क करने, समस्याओं को हल करने, अनुकूलित करने और ज्ञान का उपयोग करने की क्षमता पर चर्चा करने के लिए बुद्धि का उपयोग किया है।",
        "व्यवहारिक ज्ञान, रचनात्मकता, दृढ़ता और सांस्कृतिक अनुभव इस बात को आकार देते हैं कि लोग कैसे अर्थपूर्ण समस्याओं का समाधान करते हैं।"
      ]
    },
    {
      "heading": "IQ एक माप उपकरण है",
      "paragraphs": [
        "एक IQ स्कोर एक आयु-आधारित मानक समूह के सापेक्ष संज्ञानात्मक प्रदर्शन के एक नमूने को सारांशित करता है।",
        "कोई भी परीक्षण बुद्धिमान व्यवहार के हर रूप को नहीं देखता. कार्य, स्कोर, मानक, भाषा, और परीक्षण की स्थिति परिभाषित करती है कि परिणाम क्या समर्थन कर सकता है."
      ]
    },
    {
      "heading": "सही स्तर पर अंक प्रयोग करे",
      "paragraphs": [
        "IQ तब उपयोगी होता है जब प्रश्न साक्ष्य से मेल खाता है, जैसे कि एक व्यापक मूल्यांकन में संज्ञानात्मक शक्तियों और आवश्यकताओं के पैटर्न का वर्णन करना।",
        "एक विचारशील व्याख्या स्कोर को इतिहास, व्यवहार, वातावरण, लक्ष्यों और अन्य प्रासंगिक जानकारी के साथ जोड़ती है।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ सभी बुद्धि का माप करता है?",
      "answer": "यह महत्वपूर्ण संज्ञानात्मक क्षमताओं का नमूना लेता है लेकिन रचनात्मकता, व्यावहारिक निर्णय, बुद्धि, प्रेरणा या भावनात्मक कौशल को समाप्त नहीं करता है।"
    },
    {
      "question": "क्या कोई व्यक्ति औसत IQ के साथ बुद्धिमान हो सकता है?",
      "answer": "हाँ, एक औसत मिश्रण विशिष्ट ताकतों, विशेषज्ञता, रचनात्मकता, या प्रभावी व्यावहारिक समस्या समाधान के साथ सह-अस्तित्व कर सकता है।"
    }
  ],
  "related": ["what-is-iq", "iq-vs-eq", "how-is-iq-measured"]
}
